import { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { DEFAULT_PAGE_LIMIT, endpoints } from "../constants/api";
import { $http } from "../config/axiosConfig";

export const fetchMeterBillingPublicAsync = async (
  meterSerialNo: string,
  page = 1,
  limit = DEFAULT_PAGE_LIMIT
) => {
  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.billingPublicMeter}/${meterSerialNo}?page=${page}&limit=${limit}`
    );
    return { data: data?.data };
  } catch (error) {
    return error;
  }
};

export const initiateSTKPushAsync = async (payload: {
  meterNo: string;
  phoneNumber: string;
  amount: number;
}) => {
  const data: AxiosResponse = await $http.post(endpoints.stkPush, payload);
  return { data: data?.data };
};

export const fetchPropertyBillingAsync = async (
  propertyId: string,
  page = 1,
  limit = DEFAULT_PAGE_LIMIT
) => {
  const token = Cookies.get("token");

  try {
    const data: AxiosResponse = await $http.get(
      `${endpoints.billing}/${propertyId}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: data?.data };
  } catch (error) {
    return error;
  }
};
